import React, { useEffect, useState } from "react";
import {
    Typography,
    makeStyles,
    Paper,
    Box,
    Button,
    Divider,
    TextField,
    InputAdornment,
    TableContainer,
    Table,
    TableBody,
    TableCell,
    TableRow,
    Grid,
    Card,
    CardContent,
    Backdrop
} from "@material-ui/core";
import EnhancedTableHead from "../Signee/EnhancedTableHead";
import SearchIcon from "@material-ui/icons/Search";
import AddIcon from "@material-ui/icons/Add";
import EditContactEventDialog from "../Signee/EditContactDialog";
import CreateContactEvent from "./CreateContactEvent";
import {
    getContactEventForSignee,
} from "../../../src/store/action/signee/signeeAction";
import { headCellsContactEvent } from "../Signee/HeadcellsContactEvent";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { EditIcon } from "lucide-react";
import { getSingleTrustById } from "../../store/action/trust/trustAction";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const useStyle = makeStyles((theme) => ({
    root: {
        width: "100%",
        overflowX: "hidden",
        padding: theme.spacing(3),
        background: "#f9fafc",
    },
}
));

export default function ContactEvent({ match }) {
    const classes = useStyle();
    const [searchData, setSearchData] = useState({ search: "" });
    const [page, setPage] = React.useState(1);
    const [order, setOrder] = React.useState("desc");
    const [orderBy, setOrderBy] = React.useState("created_at");
    const user_id = match.params.id;
    const id = match.params.id;
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const handleClickOpen = () => {
        setOpen(true);
    };
    const dispatch = useDispatch();
    const loginDetail = JSON.parse(localStorage.getItem("loginUserInfo"));
    const handleClose = () => {
        setOpen(false);
    }
    const getevent = (pageNo = 1, search = "") => {
        dispatch(getContactEventForSignee(pageNo, search, user_id, orderBy, order, "customer"));
    };
    const {
        getCandidateEventItem,
    } = useSelector((state) => state.signee);

    const [visibleColumnsContactEvent, setVisibleColumnsContactEvent] = useState(
        headCellsContactEvent[0].map((col) => col.id) // initially all columns visible
    );

    const openEditDialog = (row) => {
        setEditDialog(true);
        // console.log(row)
        setContactData(row);
    };
    const [trustItems, setTrustItems] = useState([]);
    const [editDialog, setEditDialog] = useState(false);
    const [contactData, setContactData] = useState({});
    const handleSearchChange = (event) => {
        const d1 = event.target.value;
        if (d1) {
            setTimeout(getevent(page, d1), 100);
        } else {
            setTimeout(getevent(page, ""), 100);
        }
        setSearchData({ ...searchData, [event.target.name]: event.target.value });
    };
    useEffect(() => {
        getevent(1, "");
    }, [orderBy, order]);

    useEffect(() => {
        getevent(1, "");
    }, [user_id]);
    const handleRequestSort = (
        property,
        setOrder,
        setOrderBy,
        orderBy,
        order
    ) => {
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };
    const handleClickSearch = (event, value) => {
        setTimeout(getevent(page, searchData.search), 1000);
    };

    const getSingleTrust = async () => {
        setLoading(true);
        dispatch(
            getSingleTrustById(id, (result) => {
                if (result?.data) {
                    setTrustItems(result?.data);
                }
                setLoading(false);
            })
        );
    };
    useEffect(() => {
        if (id) getSingleTrust();
    }, [id]);
    const customerDetails = [
        { label: "Customers Name", value: trustItems?.name || "N/A" },
        { label: "Customer Code", value: trustItems?.code || "N/A" },
        { label: "Framework", value: trustItems?.framework || "N/A" },
        { label: "VAT", value: trustItems?.vat || "N/A" },
        { label: "LLP Status", value: trustItems?.llp_status || "N/A" },
        { label: "AWR", value: trustItems?.awr || "N/A" },
        { label: "LPP Trust Code", value: trustItems?.llp_trust_code || "N/A" },
        { label: "Cost Center Code", value: trustItems?.cost_center_code || "N/A" },
        { label: "Cash Connect No", value: trustItems?.cash_connect_no || "N/A" },
        { label: "Contract", value: trustItems?.contract || "N/A" },
    ];
    const history = useHistory();
    return (
        <>
            <div >
                <Card className={classes.card}>
                    <CardContent>
                        <Typography className="customHeading"
                        >Customer Details</Typography>
                        <Grid container spacing={2}>
                            {customerDetails.map((item, index) => (
                                <Grid item xs={12} sm={6} md={4} key={index}>
                                    <Typography className={classes.label}>{item.label}</Typography>
                                    <Typography className={classes.value}>{item.value}</Typography>
                                </Grid>
                            ))}
                        </Grid>
                        <Grid item style={{ marginTop: 20, display: "flex", justifyContent: "flex-end" }}>
                            <Button color="secondary" variant="contained" onClick={() => history.goBack(-1)}>
                                Back
                            </Button>
                        </Grid>
                    </CardContent>
                </Card>
                <Grid container justifyContent="space-between" alignItems="center" spacing={2}>
                    <Grid item>
                        <Typography variant="h5" style={{ marginBottom: 16, marginTop: 15 }}>
                            Contact Event list
                        </Typography>
                    </Grid>

                    <Grid item>
                        <Grid container alignItems="center" spacing={2}>
                            <Grid item>
                                <TextField
                                    size="small"
                                    placeholder="Search now..."
                                    name="search"
                                    variant="outlined"
                                    onChange={handleSearchChange}
                                    onKeyPress={(e) => e.key === "Enter" && handleClickSearch()}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon
                                                    style={{
                                                        color: "#856f6f", // Icon color
                                                        cursor: "pointer",
                                                    }}
                                                    onClick={handleClickSearch}
                                                />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>

                            <Grid item>
                                <Button color="secondary" variant="contained" onClick={() => handleClickOpen()}>
                                    <AddIcon className="mr-2" />
                                    Add Contact Event
                                </Button>
                            </Grid>
                        </Grid >
                    </Grid >
                </Grid >
                <TableContainer className={classes.container}>
                    <Table stickyHeader aria-label="sticky table">
                        <EnhancedTableHead
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={(event, property) =>
                                handleRequestSort(
                                    property,
                                    setOrder,
                                    setOrderBy,
                                    orderBy,
                                    order
                                )
                            }
                            rowCount={getCandidateEventItem?.data?.data?.length}
                            headCells={headCellsContactEvent[0]}
                            visibleColumns={visibleColumnsContactEvent}
                        />

                        <TableBody>
                            {getCandidateEventItem?.data?.length > 0 ? (
                                getCandidateEventItem.data.map((row, index) => (
                                    <TableRow key={index} hover>
                                        <TableCell scope="row">{index + 1}</TableCell>
                                        <TableCell >
                                            {moment(row.created_at).format("DD MMM YYYY hh:mm A")}
                                        </TableCell>
                                        <TableCell
                                            dangerouslySetInnerHTML={{ __html: row?.comment }}
                                        />
                                        {/* <TableCell>{row.comment}</TableCell> */}
                                        <TableCell>{row.first_name}</TableCell>
                                        <TableCell>
                                            {loginDetail.id === row?.created_by && (
                                                <EditIcon onClick={() => openEditDialog(row)}
                                                    style={{ cursor: "pointer" }}
                                                />
                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={5} align="center">
                                        Sorry, Contact Event not found!
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <CreateContactEvent open={open} handleClose={handleClose} signee_id={user_id} menu="customer" />
                <EditContactEventDialog
                    title="edit"
                    open={editDialog}
                    data={contactData}
                    setData={setContactData}
                    handleClose={() => setEditDialog(false)}
                />
            </div>
        </>
    )
}